import { I18n } from '@calendly/i18n';
import { DeleteIcon } from '@calendly/ui/components/icons';
import { Item } from '@calendly/ui/components/menu';
import classNames from 'classnames';
import { forwardRef } from 'react';
const deleteItemCss = "d17ejmh8";
export const DeleteItem = forwardRef((props, ref) => <Item ref={ref} {...props} className={classNames(deleteItemCss, props.className)}>
    <DeleteIcon size="large" />
    {I18n.t('publisher.action.delete')}
  </Item>);

require("./delete_item.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./delete_item.js");